import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import BillingAddress from "../../common/BillingAddress";

const ConnectedBillingAddress = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_CHECKOUT_STEP,
            state,
        ),
    );

    const {
        options: {
            billingAddress: {
                additionalText,
                billingAddressLine1Label,
                billingAddressLine2Label,
                billingCityLabel,
                billingStateLabel,
                billingZipCodeLabel,
                billingCountryLabel,
                sameasMailingAddressCheckboxLabel,
                subsectionHeading,
            },
        },
    } = control;

    const billingAddressProps = {
        displayBillingAddress: true,
        additionalText,
        billingAddressLabel: billingAddressLine1Label,
        billingAddressLabel2: billingAddressLine2Label,
        billingCityLabel,
        billingStateLabel,
        billingCountryLabel,
        billingZipLabel: billingZipCodeLabel,
        sameAsMailingLabel: sameasMailingAddressCheckboxLabel,
        subsectionHeading,
    };

    return <BillingAddress {...billingAddressProps} />;
};

ConnectedBillingAddress.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedBillingAddress;
